var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceconcierge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.98 65.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke-linecap:round;stroke-width:2px;}.cls-1,.cls-3{stroke:#e6007e;stroke-miterlimit:10;}.cls-2,.cls-3{fill:#e6007e;}.cls-3{stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "acceuil"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.8,14.61A29.8,29.8,0,0,0,1,33,32,32,0,0,0,55.61,55.61a32,32,0,0,0,0-45.24h0A31.79,31.79,0,0,0,33,1a29.47,29.47,0,0,0-17.9,5.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.53,11.62a1.57,1.57,0,1,0-1.11-.46A1.57,1.57,0,0,0,10.53,11.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M52.57,45.73H37.66l-.84-2.1H52.57a.7.7,0,0,0,.7-.7v-1.4a2.09,2.09,0,0,0-1.41-2A18.19,18.19,0,0,0,34.39,22V20.55h1.4a2.1,2.1,0,1,0,0-4.2h-4.2a2.1,2.1,0,1,0,0,4.2H33V22A18.19,18.19,0,0,0,15.52,39.56a2.1,2.1,0,0,0-1.42,2v1.4a.7.7,0,0,0,.7.7H30.56l-.84,2.1H14.8a2.1,2.1,0,0,0-2.09,2.1v1.4a.7.7,0,0,0,.7.7H54a.7.7,0,0,0,.7-.7v-1.4A2.1,2.1,0,0,0,52.57,45.73Zm-21-26.58a.7.7,0,0,1,0-1.4h4.2a.7.7,0,0,1,0,1.4Zm2.1,4.2A16.8,16.8,0,0,1,50.46,39.43H16.92A16.8,16.8,0,0,1,33.69,23.35ZM15.5,42.23v-.7a.71.71,0,0,1,.7-.7h35a.7.7,0,0,1,.7.7v.7Zm20.65,3.5H31.22l.84-2.1h3.25Zm17.12,2.8H14.1v-.7a.7.7,0,0,1,.7-.7H52.57a.7.7,0,0,1,.7.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.3,
    y: 16.35,
    width: 1.4,
    height: 4.2,
    rx: 0.68,
    transform: "translate(7.47 44.4) rotate(-89.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 27.31,
    y: 11.37,
    width: 1.4,
    height: 4.2,
    rx: 0.68,
    transform: "translate(-1.32 23.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 32.99,
    y: 10.06,
    width: 1.4,
    height: 4.2,
    rx: 0.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 40.68,
    y: 16.33,
    width: 1.4,
    height: 4.2,
    rx: 0.68,
    transform: "translate(23.06 59.86) rotate(-90.15)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 38.67,
    y: 11.35,
    width: 1.4,
    height: 4.2,
    rx: 0.68,
    transform: "translate(57.7 50.8) rotate(-135)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 28.76,
    cy: 26.29,
    r: 0.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.28,27.27a.69.69,0,0,0-.68-.71.83.83,0,0,0-.51.19A15.37,15.37,0,0,0,19.19,35a1.19,1.19,0,0,0-.11.45.67.67,0,0,0,.68.69c.54,0,.74-.63.74-.63a14,14,0,0,1,6.33-7.53.59.59,0,0,0,.17-.1h0A.72.72,0,0,0,27.28,27.27Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceconcierge);
export default __webpack_public_path__ + "static/media/serviceconcierge.0d770b2eb922c85e927977781cc7ccd6.svg";
export { ForwardRef as ReactComponent };